module.exports = __webpack_public_path__ + "fonts/AnyConv.com__SourceSansPro-BlackItalic.701f7416.woff";